
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M16 2C8.26801 2 2 8.26801 2 16c0 7.732 6.26801 14 14 14 7.732 0 14-6.268 14-14 0-7.73199-6.268-14-14-14zM0 16C0 7.16344 7.16344 0 16 0c8.8366 0 16 7.16344 16 16 0 8.8366-7.1634 16-16 16-8.83656 0-16-7.1634-16-16z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill":"currentColor","d":"M19.627 19.897c-.684.589-1.615.969-2.869.969-2.09 0-3.439-1.14-3.99-2.888h5.51l.019-1.292h-5.795c-.019-.247-.038-.4941-.038-.741 0-.285.019-.57.057-.855h5.776l.019-1.292h-5.491c.589-1.634 1.938-2.698 3.952-2.698 1.235 0 2.147.361 2.812.931l1.064-1.672c-.988-.77905-2.28-1.15905-3.876-1.15905-3.192 0-5.339 1.82405-6.042 4.59805H9.538v1.292h.969c-.019.285-.038.57-.038.855 0 .2469 0 .494.019.741h-.969L9.5 17.978h1.197c.665 2.888 2.793 4.807 6.061 4.807 1.615 0 2.926-.418 3.914-1.216l-1.045-1.672z"}})])
          )
        }
      }
    